import React from "react";
import { Box, Flex, Heading, Image, Text } from "@chakra-ui/react";
import { motion, useReducedMotion } from "framer-motion";
import Logo from "../assets/Logo.svg";
import WakoThinking from "../assets/mascots/wako/Thinking.svg";

const MotionBox = motion.create(Box);
const MotionImage = motion.create(Image);

export const LoadingPage = ({
  message = "Verificando acceso...",
  description = "Estamos preparando todo para ti.",
}) => {
  const reduceMotion = useReducedMotion();

  return <Flex
    role="status" aria-live="polite" minH="100dvh" px="6" py="10"
    bg="linear-gradient(155deg, #fff7ed 0%, #fff1f2 52%, #ffffff 100%)"
    align="center" justify="center" position="relative" overflow="hidden"
  >
    <Image src={Logo} alt="Arawaks" boxSize="38px" position="absolute" top="6" left="6"/>
    <MotionBox
      w="full" maxW="480px" textAlign="center"
      initial={reduceMotion ? false : { opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35, ease: "easeOut" }}
    >
      <Box h={{ base: "270px", md: "320px" }} position="relative">
        <MotionBox
          position="absolute" inset="8% 10%" rounded="full"
          bg="linear-gradient(145deg, #fecaca, #fda4af)" boxShadow="0 24px 60px rgba(190,18,60,.16)"
          animate={reduceMotion ? undefined : { scale: [1, 1.04, 1] }}
          transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
        />
        <MotionImage
          src={WakoThinking} alt="Wako preparando tu acceso" position="relative"
          h="full" w="full" objectFit="contain" filter="drop-shadow(0 22px 28px rgba(127,29,29,.14))"
          animate={reduceMotion ? undefined : { y: [0, -7, 0], rotate: [0, 1, 0] }}
          transition={{ duration: 2.8, repeat: Infinity, ease: "easeInOut" }}
        />
      </Box>

      <Heading mt="5" fontSize={{ base: "28px", md: "36px" }} lineHeight="1.1">{message}</Heading>
      <Text mt="3" color="gray.600">{description}</Text>
      <Box mt="8" mx="auto" w="180px" h="4px" overflow="hidden" rounded="full" bg="red.100">
        <MotionBox
          h="full" w="45%" rounded="full" bg="brand.red"
          animate={reduceMotion ? { x: "60%" } : { x: ["-110%", "225%"] }}
          transition={{ duration: 1.35, repeat: Infinity, ease: "easeInOut" }}
        />
      </Box>
    </MotionBox>
  </Flex>;
};

export default LoadingPage;
